import { TOKEN, SET_USER, REMOVE_USER } from "../../constants";


export const AuthReducer = (state, action) => {
  switch (action.type) {
    case SET_USER:
      if (action.payload?.user?.token) {
        localStorage.setItem(TOKEN, action.payload.user?.token);
      }

      return {
        ...state,
        ...action.payload,
        isAuthorized: true,
      };
    case REMOVE_USER:
      localStorage.clear();

      return {
        ...state,
        user: {},
        isAuthorized: false,
      };
    default:
      return state;
  }
};
